import { render, staticRenderFns } from "./TourRoomExtras.vue?vue&type=template&id=49405674&"
import script from "./TourRoomExtras.vue?vue&type=script&lang=js&"
export * from "./TourRoomExtras.vue?vue&type=script&lang=js&"
import style0 from "./TourRoomExtras.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TourRoomExtras.vue"
export default component.exports